import { optionalWeightedAvg } from "../shared";

export const aggregateMargin = (rows, convert) =>
  optionalWeightedAvg(rows, (row) => convert(row.marginPercent), (row) => row.realized);